import React from 'react';
import { Form } from 'semantic-ui-react'

export default function DisplayField(props) {
  return <Form.Input {...props} onInput={ignoreEvent} onPaste={ignoreEvent} onKeyPress={ignoreEvent} />
}

function ignoreEvent(e) {
    e.preventDefault()
    return false
}


// WEBPACK FOOTER //
// ./components/custom/DisplayField.js